import * as React from 'react';
import cx from 'classnames';
import shallowEqual from 'utils/shallowEqual';
import Lazyload from 'utils/lazyloadUtil';
import { addClass, loadImage } from 'utils/domHelper';
import placeholderImg from 'images/placeholder.svg';
import styles from './ProgressiveImage.css';
export default class ProgressiveImage extends React.Component {
    constructor(props) {
        super(props);
        this.onActualImgLoad = () => {
            if (typeof this.props.onImageLoad === 'function') {
                this.props.onImageLoad(this.actualImgRef);
            }
        };
        this.onActualImgError = () => {
            if (typeof this.props.onImageError === 'function') {
                this.props.onImageError(this.actualImgRef);
            }
        };
        this.onPreloadImageLoad = () => {
            if (!this.preloadImgRef)
                return;
            this.preloadImgWidth = this.preloadImgRef.width;
            this.preloadImgHeight = this.preloadImgRef.height;
            if (typeof this.props.onPreImageLoad === 'function') {
                this.props.onPreImageLoad(this.preloadImgRef);
            }
            this.setState({ preloadImgLoaded: true });
        };
        this.setActualImgRef = (c) => {
            this.actualImgRef = c;
        };
        this.setPreloadImgRef = (c) => {
            this.preloadImgRef = c;
        };
        this.state = {
            preloadImgLoaded: false
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!shallowEqual(this.props, nextProps)) {
            if (this.lazyId)
                Lazyload.unregister(this.lazyId);
            this.registerForLazyLoad();
        }
    }
    componentDidMount() {
        this.registerForLazyLoad();
    }
    componentWillUnmount() {
        if (this.lazyId)
            Lazyload.unregister(this.lazyId);
    }
    registerForLazyLoad() {
        const imgRef = this.actualImgRef;
        if (!imgRef || !this.preloadImgRef)
            return;
        const loadedClass = styles['progressive-image-loaded'];
        const loadedCallback = () => {
            this.lazyId && Lazyload.unregister(this.lazyId);
            if (typeof this.props.onLazyLoad === 'function') {
                this.props.onLazyLoad();
            }
            return loadImage(imgRef, this.props.src, placeholderImg, this.props.highResSrc)();
        };
        this.lazyId = Lazyload.register(this.preloadImgRef, loadedCallback);
        imgRef.onload = _ => {
            window.requestAnimationFrame(() => {
                addClass(imgRef, loadedClass);
                this.onActualImgLoad();
            });
        };
        imgRef.onerror = _ => {
            window.requestAnimationFrame(() => {
                imgRef.src = placeholderImg;
                addClass(imgRef, loadedClass);
                this.onActualImgError();
            });
        };
    }
    render() {
        const { src, containerStyle, preloadSrc, initialBlur, scale, preloadImgClassName, className, containerClassName, impressionId } = this.props;
        const { preloadImgLoaded } = this.state;
        // preloadImgLoaded value will not be set if the page is reloaded (the
        // preload image gets cached by browser and won't trigger the onLoad
        // callback), so just checking scale && preloadImgLoaded flag logic is
        // faulty in this condition. So, we're now checking the case where the
        // preloadImgLoaded flag is never set. If that's the case, we'll
        // default to using the `scale` attribute.
        const canUsePreloadImgDimensions = preloadImgLoaded || typeof preloadImgLoaded === 'undefined';
        const progressiveImageClasses = cx({
            [styles['progressive-img-cont']]: true,
            [styles['scale-width']]: canUsePreloadImgDimensions && scale && this.preloadImgWidth >= this.preloadImgHeight,
            [styles['scale-height']]: canUsePreloadImgDimensions && scale && this.preloadImgWidth < this.preloadImgHeight
        }, containerClassName);
        return (<div className={progressiveImageClasses} style={containerStyle}>
				<img data-fdp-tracking-test={impressionId} ref={this.setActualImgRef} className={cx(styles['actual-img'], className)} alt={this.props.alt || ''}/>
				<img ref={this.setPreloadImgRef} className={cx(styles['preload-img'], { [styles['blur']]: initialBlur }, preloadImgClassName)} src={preloadSrc || src} alt={this.props.alt || ''} onLoad={this.onPreloadImageLoad}/>
			</div>);
    }
}
ProgressiveImage.defaultProps = {
    src: placeholderImg,
    initialBlur: true,
    scale: true,
    containerStyle: { width: '100%', height: '100%' }
};
